(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-manager/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-manager/assets/javascripts/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$components$tipse = svs.components.tipsen.drawSelector.constants,
  DRAW_SORT_FLOW = _svs$components$tipse.DRAW_SORT_FLOW,
  DRAW_SORT_QS = _svs$components$tipse.DRAW_SORT_QS,
  DRAW_FILTER_QS = _svs$components$tipse.DRAW_FILTER_QS;
const getFundInfoToShow = svs.components.tipsen.drawCard.utils.getFundInfoToShow;
const SportTypeToString = svs.components.sport.sportTypes.SportTypeToString;
const productIds = svs.utils.products.productIds;

const sortDraws = (drawsData, sortFlow) => [...drawsData].sort((a, b) => {
  if (a.drawStateId !== b.drawStateId) {
    return b.drawStateId - a.drawStateId;
  }
  if (sortFlow === DRAW_SORT_FLOW.NET_SALE.value) {
    const aCurrentNetSale = parseInt(a.currentNetSale, 10) || 0;
    const bCurrentNetSale = parseInt(b.currentNetSale, 10) || 0;
    if (aCurrentNetSale !== bCurrentNetSale) {
      return bCurrentNetSale - aCurrentNetSale;
    }
  } else if (sortFlow === DRAW_SORT_FLOW.EXTRA_MONEY.value) {
    var _a$extraMoney, _b$extraMoney;
    const aExtraMoneyAmount = parseInt((_a$extraMoney = a.extraMoney) === null || _a$extraMoney === void 0 ? void 0 : _a$extraMoney.amount, 10) || 0;
    const bExtraMoneyAmount = parseInt((_b$extraMoney = b.extraMoney) === null || _b$extraMoney === void 0 ? void 0 : _b$extraMoney.amount, 10) || 0;
    if (aExtraMoneyAmount !== bExtraMoneyAmount) {
      return bExtraMoneyAmount - aExtraMoneyAmount;
    }
  }

  const aRegCloseTime = new Date(a.regCloseTime).getTime();
  const bRegCloseTime = new Date(b.regCloseTime).getTime();
  if (aRegCloseTime !== bRegCloseTime) {
    return aRegCloseTime - bRegCloseTime;
  }

  return a.drawNumber - b.drawNumber;
});
const useHandleSortDraws = drawsData => {
  var _drawsData$;
  const qs = new URLSearchParams(window.location.search);
  const sortFlowFromUrl = qs.get(DRAW_SORT_QS);
  const isMatchen = (drawsData === null || drawsData === void 0 || (_drawsData$ = drawsData[0]) === null || _drawsData$ === void 0 ? void 0 : _drawsData$.productId) === productIds.MATCHEN;
  const sortFlow = sortFlowFromUrl || (isMatchen ? DRAW_SORT_FLOW.NET_SALE.value : undefined);
  const sortedDrawsData = useMemo(() => {
    if (drawsData.length < 2) {
      return drawsData;
    }
    const sortedDraws = sortDraws(drawsData, sortFlow);
    return sortedDraws;
  }, [drawsData, sortFlow]);
  return sortedDrawsData;
};
const useFilterDraws = drawsData => {
  const qs = new URLSearchParams(window.location.search);
  const filterFromUrl = qs.getAll(DRAW_FILTER_QS).toString();
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  useEffect(() => {
    const values = filterFromUrl.split(',');
    setFilter(values.filter(value => Boolean(value)));
  }, [filterFromUrl]);
  const amountOfSports = useMemo(() => {
    const sports = new Set();
    drawsData.forEach(draw => {
      sports.add(draw.sportType);
    });
    return sports.size;
  }, [drawsData]);
  const filteredDrawsData = useMemo(() => {
    if (amountOfSports <= 1 || !filter || !filter.length) {
      return drawsData;
    }
    const filteredData = drawsData.filter(draw => filter.includes(SportTypeToString[draw.sportType]));
    return filteredData.length ? filteredData : drawsData;
  }, [filter, drawsData, amountOfSports]);
  return filteredDrawsData;
};
const composeDrawWithFunds = (draws, allFunds) => {
  const composedDraws = draws.map(draw => {
    const fundData = allFunds.find(fund => fund.drawNumber === draw.drawNumber);
    const extraMoney = getFundInfoToShow(fundData);
    return _objectSpread(_objectSpread({}, draw), {}, {
      extraMoney
    });
  });
  return composedDraws;
};
setGlobal('svs.components.tipsen.drawManager.utils', {
  composeDrawWithFunds,
  sortDraws,
  useFilterDraws,
  useHandleSortDraws
});

 })(window);